import selectValue from './selectValue.js';
import datepicker from './datepicker.js';
import formValidation from './formValidation.js';
import httpRequest from './httpRequest.js';

const aTable = {

	data: null,
	lastChecked: null,
	cookieName: 'atable-list-col-v2',

	/**
	 * Initialiseer de aTable
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {

		const tableElement = target.querySelector('[data-atable]');

		if (typeof tableElement !== 'undefined' && tableElement !== null) {

			const table = $(tableElement);

			var loaded = table.prop('atable-loaded');
			if (typeof loaded === 'undefined') {
				table.prop('atable-loaded', true);
			}

			aTable.initSort(table);
			aTable.initEvents(table);
			aTable.initListLength(table);
			aTable.initColumnsToggle(table);
			aTable.initLength(table);
			aTable.load(table);
			aTable.initSearch(table);
		}
	},

	/**
	 * Initialiseer de sortering
	 * Definieer default sortering, zoek naar een eventuele voorkeurssortering en pas sortering toe
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	initSort: function(table) {

		// Definieer default sortering en volgorde
		var sort = 1;
		var order = 'asc';

		// Verkrijg eventuele voorkeurssortering uit kolommen
		var col = table.find('th[data-aitem-default-sorting]').first();
		if (col.length) {
			sort = col.index();
			order = col.data('aitem-default-sorting');
		}

		// Pas de sortering toe
		table.data('sort', sort);
		table.data('order', order);

	},

	/**
	 * Initialiseer de event handlers
	 * Definieer DOM basis element en bind click handler aan gewenste elementen
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	initEvents: function(table) {

		// Click handler base element
		var base = $(document.body).find(table.closest('[data-atable-container]'));

		// Paginering events
		base.on('click', '[data-atable-pagination-link]', function(event) {
			event.preventDefault();
			aTable.page(event, table);
		});

		// Sorterings events
		base.on('click', '[data-atable-column-sorting]', function(event) {
			aTable.sort(event, table);
		});

		// Zoek events
		base.on('click', '[data-atable-header-toolbar-searchbutton]', function() {
			aTable.search(table);
		});
		// Zoek reset events
		base.on('click', '[data-atable-header-toolbar-resetButton]', function() {
			aTable.searchReset(table);
		});

		// Zoek header toolbar events
		base.on('click', '[data-atable-header-filter-search-button]', function() {
			aTable.reload(table);
		});

		// Download events
		base.on('click', '[data-atable-header-toolbar-downloadbutton]', function() {
			aTable.download(table);
		});

		// Modal events
		base.on('click', '.showListingModal, [data-atable-toggle-listing-modal]', function(event) {
			event.preventDefault();
			aTable.getModal(event, table);
		});

		// List events
		base.on('click', '[data-atable-list-title-container], [data-atable-list-summary]', function(event) {
			aTable.listClick(event, base);
		});

		// Table row click opend eerste action
		base.on('click', 'tbody tr', function(event) {
			aTable.tableClick(event, table);
		});

		// Voorkom klik functie op dropdown menu
		base.on('click', '[data-atable-header-toggle] .dropdown-menu', function(event) {
			event.stopPropagation();
		});

		// Toon of verberg kolom wanneer filter gewijzigd wordt en sla status op in cookie
		base.on('change', '[data-atable-header-toggle-items] a input', function(event) {
			aTable.toggleColumn(event, table);
		});

		// Zoekvelden keyboard enter key events
		base.on('keypress', '[data-atable-header-filter-search-input]', function(event) {
			var keycode = (event.keyCode ? event.keyCode : event.which);
			if (keycode == '13') {
				aTable.reload(table);
			}
			aTable.searchEnterKeySubmit(event, table);
		});

		// Bulk header button functie die checkboxes toont
		base.on('click', '[data-atable-header-toolbar-bulkbutton]', function() {
			aTable.bulkToggleCheckboxColumn(table);
		});

		// Bulk header checkbox function om select all te doen
		base.on('click', 'table[data-atable] thead tr th input[type=checkbox]', function(event) {
			aTable.bulkCheckboxToggleAll(event);
		});

		// Bulk functie om verticale shift selectie te doen
		base.on('click', 'table[data-atable] tbody tr td input[type=checkbox]', function(event) {
			aTable.bulkCheckboxShiftClickSelect(event);
		});

		// Bulk functie om bulk edit button enabled of disabled te maken als er een checkbox geselecteerd wordt
		base.on('change', 'table[data-atable] tbody tr td input[type=checkbox]', function() {
			aTable.bulkToggleEditButton(table);
		});

		// Table header events
		base.on('change', '[data-atable-header-toolbar-length],[data-atable-header-filter-select],[data-atable-header-filter-search-input], [data-atable-header-toolbar-select]', function() {
			aTable.reload(table);
		});

		// Table modal filter events
		base.on('change', '[data-atable-modal-filter-select],[data-atable-modal-filter-search-input]', function(event) {
			aTable.modalFilterApplyInputToHeader(table, event);
		});

		// Window resize length to 100 event
		var resizeId;
		var w = $(window).width();
		$(window).resize(function() {
			if (w != $(window).width()) {
				clearTimeout(resizeId);
				resizeId = setTimeout(function() {
					aTable.reload(table);
				}, 1000);
			}
		});


	},

	modalFilterApplyInputToHeader: function(table) {

		let base = $(document.body).find(table.closest('[data-atable-container]'));
		let targetId;
		let target;
		let sourceValue;
		let targetValue;
		base.find('[data-atable-modal-search-id], [data-atable-modal-filter-id]').each(function(i, e) {
			targetId = $(e).data('atable-modal-search-id') || $(e).data('atable-modal-filter-id');
			sourceValue = $(e).val();
			if (targetId !== 'undefined') {
				target = $('[data-atable-search-id=' + targetId + ']');
				if (!target.length) {
					target = $('[data-atable-filter-id=' + targetId + ']');
				}
				targetValue = target.val();
				if (sourceValue !== targetValue) {
					target.val(sourceValue);
					$(target).trigger('change');
				}
			}
		});

	},

	initSearch: function(table) {

		// Verkrijg optie om searcg aan en uit te zetten uit DOM en default naar false
		var searchable = table.data('searchable');
		if (typeof searchable === 'undefined') {
			searchable = false;
		}

		// Initieer search
		if (searchable === true) {
			var searchButton = table.closest('[data-atable-container]').find('[data-atable-header-toolbar-searchbutton]');
			searchButton.addClass('d-xl-inline-block ');
		}

	},

	/**
	 * Initieer de listing length
	 * Zet de length op 100 als de listing view geactiveerd is
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	initListLength: function(table) {
		var listVisible = table.closest('[data-atable-container]').find('[data-atable-list-listing]').is(':visible') || false;
		var lengthSelect = table.closest('[data-atable-container]').find('[data-atable-header-toolbar-length]');
		if (listVisible) {
			lengthSelect.val('500');
		}
	},

	initLength: function(table) {

		// Verkrijg optie om length selectie aan en uit te zetten uit DOM en default naar false
		var lengthSelectable = table.data('length-selectable');
		if (typeof lengthSelectable === 'undefined') {
			lengthSelectable = true;
		}

		// Initieer length selectie
		if (lengthSelectable === true) {
			var tableLength = table.closest('[data-atable-container]').find('[data-atable-header-toolbar-length]');
			tableLength.addClass('d-xl-inline-block');
		}

	},

	/**
	 * Initieer de columns toggle functie
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	initColumnsToggle: function(table) {

		// Verkrijg optie om toggle aan en uit te zetten uit DOM en default naar false
		var toggleable = table.data('toggleable');
		if (typeof toggleable === 'undefined') {
			toggleable = false;
		}

		// Initieer columstoggle
		if (toggleable === true) {

			var toggleButton = table.closest('[data-atable-container]').find('[data-atable-header-toggle]');
			toggleButton.addClass('d-xl-inline-block ');

			// Laad het data columns json object
			var columnsDump = table.data('columns-data');

			// Check of het data columns json object gedefinieerd is
			if (columnsDump && columnsDump.length > 2) {

				// Check of er een cookie is en zo ja activeer de kolommen
				aTable.toggleColumnsReadCookie(table);

			}

		}

	},

	/**
	 * Laad de tabel inhoud
	 * Definieer de query, lock de tabel, haal data op, formatteer rows en update inhoud
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	load: function(table) {

		// Check of de tabel niet gelocked is
		if (table.data('lock') == '') {

			// Definieer benodigde variables voor
			var length = parseInt($('[data-atable-header-toolbar-length]').val()) || parseInt($('[data-atable]').data('table-default-length')) || 15;
			var pagina = parseInt(table.data('pagina'));
			var start = (pagina * length);
			var queryString = aTable.formatQuery(table);
			var dateTime = new Date();
			var lock = dateTime.getTime();
			var opacityGroup = table.closest('[data-atable-container]').find('[data-atable-header-toolbar],[data-atable-table-container],[data-atable-list-listing],[data-atable-footer-toolbar]');
			var container = table.closest('[data-atable-container]');
			var spinner = table.closest('[data-atable-container]').find('[data-atable-spinner]');
			var bulkActive = table.attr('data-atable-bulk-active') || false;

			//  Lock the datatable
			table.data('lock', lock);

			// Change loading visibility
			container.removeClass('opacity-0');
			opacityGroup.addClass('opacity-25 pointer-events-none user-select-none');
			spinner.addClass('d-table').removeClass('d-none');

			// Voer de query uit
			httpRequest.send('GET', window.app.url + 'data?lock=' + lock + queryString, function(dataString) {
				let data = JSON.parse(dataString);
				if (typeof data.sql !== 'undefined') {
					console.log(data.sql);
				}
				// Check of de tabel gelocked is
				if (lock == data.lock) {

					aTable.data = data;

					// Update inhoud en info
					var draw = data.draw;
					var list = aTable.formatList(table, data);
					var rows = aTable.formatRows(data, table);
					var tableInfo = table.closest('[data-atable-container]').find('[data-atable-info]');
					var tableInfoFilter = table.closest('[data-atable-container]').find('[data-atable-info-filter]');
					var tablePagination = table.closest('[data-atable-container]').find('[data-atable-pagination]');

					aTable.content(table, draw, rows['html'], list);
					aTable.info(table, start, length, rows['notEmpty'], data);
					opacityGroup.removeClass('opacity-25 pointer-events-none user-select-none');
					spinner.addClass('d-none').removeClass('d-table');
					table.parent().removeClass('invisible');
					if (data.recordsFiltered < length) {
						tableInfoFilter.addClass('invisible');
						tablePagination.addClass('invisible');
					} else {
						tableInfo.removeClass('invisible');
						tableInfoFilter.removeClass('invisible');
						tablePagination.removeClass('invisible');
					}

					var target = $('table[data-atable]').find('thead tr th:first-child, tbody tr td:first-child');
					if (bulkActive === 'true') {
						target.removeClass('d-none');
					}

					table.trigger('aTable:loaded');

				}
			});
		}

	},

	/**
	 * Geeft zichtare listing terug
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {string}
	 */
	view: function(table) {
		var listVisible = table.closest('[data-atable-container]').find('[data-atable-list-listing]').is(':visible') || false;
		if (listVisible) {
			return 'list';
		} else {
			return 'table';
		}
	},

	/**
	 * Herlaad de tabel inhoud
	 * Ga naar eerste pagina en laad de tabel data
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	reload: function(table) {

		// Set page to first
		table.data('pagina', 0);

		// Get the data
		aTable.load(table);
	},

	/**
	 * Formatteer query
	 * Stel de ajax query string samen uit waardes van elementen in de in DOM
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {string} Geformatteerde string t.b.v. ajax request aan aItem
	 */
	formatQuery: function(table) {

		// Get sorting and order from table
		var sort = table.data('sort');
		var order = table.data('order');

		// Format sort and order query
		var sortQuery = '&sort=' + sort + '&dir=' + order;

		// Format filter query
		var filterQuery = '';
		$('[data-atable-header-filter-select],[data-atable-header-toolbar-select]').each(function() {
			var select = $(this);
			var filterTarget = select.attr('data-atable-filter-id') || select.attr('id');
			filterQuery = filterQuery + '&filter[' + filterTarget.substr(7) + ']=' + select.val();
		});

		// Format search query
		var searchQuery = '';
		$('input.aTableZoek').each(function() {
			var input = $(this);
			var searchTarget = input.attr('data-atable-search-id') || input.attr('id');
			searchQuery = searchQuery + '&search[' + searchTarget.substr(5) + ']=' + input.val();
		});

		// Format draw
		var draw = parseInt(table.data('draw'));
		var drawQuery = '&draw=' + draw;

		// Format length
		var length = parseInt(table.closest('[data-atable-container]').find('[data-atable-header-toolbar-length]').val()) || parseInt($('[data-atable]').data('table-default-length')) || 15;
		var lengthQuery = '&length=' + length;

		// Format page number
		var pagina = parseInt(table.data('pagina'));
		var start = (pagina * length);
		var startQuery = '&start=' + start;

		// Format full query
		var query = drawQuery + startQuery + lengthQuery + sortQuery + filterQuery + searchQuery;

		// Return the full query
		return query;

	},

	/**
	 * Formatteer tabelregels
	 * Maak de tabelregels aan op basis van de opgehaalde json data
	 *
	 * @param {object} data
	 * @returns {array}
	 */
	formatRows: function(data, table) {
		var headers = table.data('columns-data');
		var tbdy = document.createElement('tbody');
		var notEmpty = false;
		var totalRows = data.data.length;
		var td;
		var tr;
		for (var r = 0; r < totalRows; r++) {
			tr = document.createElement('tr');
			for (var c = 0; c < data.data[r].length; c++) {
				td = document.createElement('td');
				if (headers[c].hidden == true) {
					td.className = 'd-none';
				}
				if (headers[c].key == 'contextualClass') {
					tr.className = 'table-' + data.data[r][c];
				}
				if (headers[c].cssClass !== undefined && headers[c].cssClass !== '') {
					td.className = headers[c].cssClass;
				}
				td.innerHTML = data.data[r][c];
				// td.setAttribute('data-raw', data.data[r][c]);
				tr.appendChild(td);
				notEmpty = true;
			}
			tbdy.appendChild(tr);
		}
		if (!notEmpty) {
			tr = document.createElement('tr');
			td = document.createElement('td');
			td.innerHTML = table.data('text-no-result');
			td.colSpan = headers.length;
			td.classList = 'text-center p-4 aTable-no-result';
			tr.appendChild(td);
			tbdy.appendChild(tr);
		}
		var arr = [];
		arr['notEmpty'] = notEmpty;
		arr['html'] = tbdy;
		return arr;
	},

	/**
	 * Formatteer lijstweergave
	 * Maak de list items aan op basis van de opgehaalde json data
	 *
	 * @param {object} table
	 * @param {object} data
	 * @returns {array}
	 */
	formatList: function(table, data) {

		var template = table.closest('[data-atable-container]').find('[data-atable-list-item]').first();
		var notEmpty = false;
		var totalRows = data.data.length;
		var returnArray = [];
		var columnsDump = table.data('columns-data');

		for (var r = 0; r < totalRows; r++) {

			// Clone listing item
			var item = template.clone();
			var titleColumn = 0;

			// Vul de titel en eventuele contextual class (kleur van regel)
			for (var n = 1; n < data.data[r].length; n++) {
				if (data.data[r][n] != '') {
					if (typeof columnsDump[n] !== 'undefined') {

						// Vul de titel
						if (columnsDump[n]['responsiveOrder'] === 0) {
							titleColumn = n;
						}

						// Vul de context class
						var columnKey = columnsDump[n]['key'] || false;
						if (columnKey === 'contextualClass' && data.data[r][n] !== '') {
							var contextualClass = 'list-group-item-' + data.data[r][n];
							item.addClass(contextualClass);
						}

					}
				}
			}
			item.find('[data-atable-list-title]').html(data.data[r][titleColumn]);

			// Item details
			var itemDetailTemplate = item.find('[data-atable-list-summary-item]').first();
			var itemDetails = [];
			var itemDetail;

			var last = data.data[r].length;
			item.find('[data-atable-list-item-buttons]').html(data.data[r][(last - 1)]);
			item.removeClass('d-none');

			for (var c = 0; c < data.data[r].length; c++) {
				if (data.data[r][c] != '' && c !== titleColumn) {
					var responsiveOrder = columnsDump[c]['responsiveOrder'] || false;
					if (responsiveOrder !== false) {
						itemDetail = itemDetailTemplate.clone().removeClass('d-none').html(data.data[r][c]);
						itemDetails[(responsiveOrder - 1)] = itemDetail;
					}
				}
			}

			// Voeg details toe aan summary
			item.find('[data-atable-list-summary]').append(itemDetails);

			// Voeg item toe aan items
			returnArray.push(item);

			notEmpty = true;
		}

		if (!notEmpty) {
			item = template.clone();
			item.html(table.data('text-no-result'));
			item.removeClass('d-none');
			returnArray.push(item);
		}

		return returnArray;
	},

	/**
	 * Vul table content
	 * Update de tabel content met ingegeven html
	 *
	 * @param {object} table jQuery table DOM element
	 * @param {string} draw
	 * @param {string} html
	 * @param {string} list
	 * @returns {void}
	 */
	content: function(table, draw, html, list) {
		table.data('lock', '');
		table.data('draw', draw);
		table.find('tbody').remove();
		table.closest('[data-atable-container]').find('[data-atable-list-item]').not(':first').remove();
		var view = aTable.view(table);
		if (view == 'table') {
			table.find('thead').after(html);
		} else {
			table.closest('[data-atable-container]').find('[data-atable-list-item]').first().after(list);
		}
		table.trigger('aTable:draw');
	},

	/**
	 * Sorteer
	 * Pas nieuwe sortering toe op basis van de geklikte kolomheader
	 *
	 * @param {object} e
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	sort: function(event, table) {

		// Definieer de table kolom header als jquery element
		var th = $(event.target);

		// Check de kolom sorteerbaar is
		if (th.data('orderable') == true) {

			// Draai kolom volgorde om
			$(th).parent().find('i').removeClass('fa-sort-up').removeClass('fa-sort-down').addClass('fa-sort');
			if (th.data('order') == 'ASC') {
				th.data('order', 'DESC');
				$(th).find('i').removeClass('fa-sort-down').addClass('fa-sort-up');
			} else {
				th.data('order', 'ASC');
				$(th).find('i').removeClass('fa-sort-down').addClass('fa-sort-down');
			}



			// Pas de sortering toe op tabel element
			table.data('order', th.data('order'));
			table.data('sort', th.index());

			// Laad de tabel inhoud
			aTable.load(table);

		}
	},

	/**
	 * Laad pagina
	 * Ga naar de pagina op basis van de aangegeven waarde in geklikt element
	 *
	 * @param {object} event
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	page: function(event, table) {

		// Verkrijg het doel uit de DOM
		var index = $(event.target).data('at-idx');

		// Verijg huidige pagina uit DOM
		var pageCurrent = parseInt(table.data('pagina'));

		// Formatteer het nieuwe als int
		var page;
		if (index == 'next') {
			page = (pageCurrent + 1);
		} else if (index == 'prev') {
			page = Math.max(0, (pageCurrent - 1));
		} else {
			page = (parseInt(index) - 1);
		}

		// Pas doelpagina toe op table element
		table.data('pagina', page);

		// Laad de tabel inhoud
		aTable.load(table);
	},

	/**
	 * Toon en verberg filters in tabelheader als op de zoek knop geklikt wordt
	 *
	 * @param {object} table jQuery table DOM elementParentjq
	 * @returns {void}
	 */
	searchReset: function(table) {
		table.find('.aTable-header-filters').find('input, select').val('').trigger('change');
	},

	/**
	 * Reset de waarden van de filter
	 *
	 * @param {object} table jQuery table DOM elementParentjq
	 * @returns {void}
	 */
	search: function(table) {
		table.closest('[data-atable-container]').find('.aTable-header-filters').toggleClass('d-none');
		var resetButton = table.closest('[data-atable-container]').find('[data-atable-header-toolbar-resetButton]');
		if (resetButton[0]?.hasAttribute('disabled')) {
			resetButton?.addClass('d-xl-inline-block').removeAttr('disabled');
		} else {
			resetButton?.removeClass('d-xl-inline-block').attr('disabled', true);
		}
	},

	/**
	 * Functie die enter toets aan reload koppelt
	 *
	 * @param {object} table jQuery table DOM elementParentjq
	 * @returns {void}
	 */
	searchEnterKeySubmit: function(event, table) {
		var keycode = (event.keyCode ? event.keyCode : event.which);
		if (keycode == '13') {
			aTable.reload(table);
		}
	},

	/**
	 * Functie de een download url formatteerd en ophaald
	 *
	 * @param {object} table jQuery table DOM elementParentjq
	 * @returns {void}
	 */
	download: function(table) {
		var queryString = aTable.formatQuery(table);
		var btn = $('[data-atable-header-toolbar-downloadbutton]');
		var xhr = new XMLHttpRequest();
		btn.find('i').addClass('d-none');
		btn.find('.spinner').removeClass('d-none');
		xhr.responseType = 'arraybuffer';
		xhr.open('GET', window.app.url + 'download?' + queryString, true);
		xhr.send();
		xhr.onload = function() {
			if (this.status == 200) {
				var blob = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				window.location.href = window.URL.createObjectURL(blob);
				btn.find('i').removeClass('d-none');
				btn.find('.spinner').addClass('d-none');
			}
		};
	},

	/**
	 * Tabelinformatie
	 * Vul de gewenste DOM elementen met informatie over de opgehaalde data
	 *
	 * @param {table} data
	 * @param {int} start
	 * @param {int} length
	 * @param {bool} notEmpty
	 * @param {object} data
	 * @returns {void}
	 */
	info: function(table, start, length, notEmpty, data) {

		// Define target elements in DOM
		var tableContainer = table.closest('[data-atable-container]');
		var infoStartEl = tableContainer.find('[data-atable-info-start]');
		var infoEndEl = tableContainer.find('[data-atable-info-end]');
		var infoTotalEl = tableContainer.find('[data-atable-info-total]');
		var infoTotalTotalEl = tableContainer.find('[data-atable-filter-total]');
		var pagineationEl = tableContainer.find('[data-atable-pagination]');
		var paginationPreviousEl = tableContainer.find('[data-atable-pagination-previous]');
		var paginationNextEl = tableContainer.find('[data-atable-pagination-next]');

		// Update the content of the info elements in DOM
		infoStartEl.html(start);
		infoEndEl.html(start + data.data.length);
		infoTotalTotalEl.html(data.recordsTotal);
		infoTotalEl.html(data.recordsFiltered);

		if (notEmpty) {
			infoStartEl.html(start + 1);
			infoTotalTotalEl.parent().removeClass('invisible').addClass('invisible');
			if (data.recordsFiltered != data.recordsTotal) {
				infoTotalTotalEl.parent().removeClass('invisible');
			}

			var pagination = [];
			var max = 2;
			var maxEromheen = (max * length);
			var maxOnder = start - maxEromheen;
			var maxBoven = start + maxEromheen + (-1 * Math.min(0, maxOnder));
			maxOnder = maxOnder + Math.min(0, (data.recordsFiltered - maxBoven - (2 * length)));
			var last = '';
			for (var b = 0; b * length < data.recordsFiltered; b++) {
				var begin = b * length;
				if (begin == 0 || ((begin > maxOnder && begin <= maxBoven)) || ((begin + length) >= data.recordsFiltered)) {
					var paginanr = (begin / length) + 1;
					pagination.push(paginanr);
					last = paginanr;
				} else {
					if (last != '...') {
						paginanr = '...';
						pagination.push(paginanr);
						last = paginanr;
					}
				}
			}
			var paginationTxt = '';
			for (var s = 0; s < pagination.length; s++) {
				paginanr = pagination[s];
				var className = '';
				if (paginanr == '...') {
					className = 'disabled';
				} else if (((paginanr - 1) * length) == (start)) {
					className = 'active';
					paginationPreviousEl.parent().removeClass('disabled');
					paginationNextEl.parent().removeClass('disabled');
					if (s == 0) {
						paginationPreviousEl.parent().addClass('disabled');
					} else if ((s + 1) == pagination.length) {
						paginationNextEl.parent().addClass('disabled');
					}
				}
				paginationTxt = paginationTxt + '<li class="page-item generated  ' + className + '"><a data-atable-pagination-link href="#" data-at-idx="' + paginanr + '" tabindex="0" class="page-link">' + paginanr + '</a></li>';
			}
			if (paginationTxt != '') {
				pagineationEl.find('li.generated').remove();
				paginationPreviousEl.parent().after(paginationTxt);
			}
		} else {
			pagineationEl.find('li.generated').remove();
			paginationPreviousEl.parent().after('');
		}

	},

	/**
	 * Tableweergave click functie
	 * Open url van eerste link in actie kolom
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	tableClick: function(event, table) {

		var tableRowClickable = table.data('table-row-clickable') || false;
		if (tableRowClickable == true) {
			var item = $(event.target).closest('tr').find('td:last-child a');
			if (item.length) {
				var url = item.attr('href');
				if (typeof url !== 'undefined') {
					window.open(url);
				}
			}
		}

	},

	/**
	 * Lijstweergave click functie
	 * Toon actie buttons als op een item in de lijst geklikt wordt
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	listClick: function(e, base) {

		// Definieer listing-item als jQuery element
		var item = $(e.target).closest('[data-atable-list-item]');
		var itemButtonsContainer = item.find('[data-atable-list-item-buttons]');
		var itemButtons = itemButtonsContainer.find('.btn');

		// Als er maar één button is laad dan de link van die button
		if (itemButtons.length === 1) {

			var url = $(itemButtons[0]).attr('href');
			if (typeof url !== 'undefined') {
				window.location.href = url;
			} else {
				$(itemButtons[0]).trigger('click');
			}


			// Als er verschilende buttons zijn toon dan die buttons
		} else {

			// Verberg eventueel getoonde buttons in de list en toon eventueel verborgen list-item content
			base.find('[data-atable-list-item-buttons]').addClass('d-none');
			base.find('[data-atable-list-title-container],[data-atable-list-summary]').removeClass('invisible');

			// Verberg item titel en samenvatting
			item.find('[data-atable-list-title-container],[data-atable-list-summary]').addClass('invisible');

			// Pas aanvullende opmaak classes toe en toon buttens
			itemButtonsContainer.find('.btn').removeClass('btn-xs').addClass('m-0 px-2 ma-1');
			itemButtonsContainer.removeClass('d-none');

		}

	},

	/**
	 * Toon en verberg modal
	 *
	 * @param {int} data_id
	 * @param {string} link
	 * @returns {void}
	 */
	loadListingModal: function(data_ids, link, size) {
		var url = window.app.url + link + '/';
		httpRequest.send('POST', url, function(data) {
			if (data != 'false' && data != '') {

				let modal = $('[data-atable-modal]');
				let modalContent = $('[data-atable-modal-content]');
				let modalDialog = $('[data-atable-modal] .modal-dialog');

				modalDialog.addClass('modal-' + size);
				modalContent.html(data);
				modal.modal('show');

				selectValue.init(modal);
				datepicker.init(modal);
				formValidation.init(modal[0]);

			} else {
				console.error('Er ging iets mis, probeer het later nogmaals');
			}
		}, httpRequest.encodeFormData({data_ids: data_ids}));
	},

	/**
	 * Toon en verberg modal
	 *
	 * @param {object} event
	 * @returns {void}
	 */
	getModal: function(event, table) {

		var button = $(event.target);

		var data_id = button.attr('data-id') || null;
		var data_ids = [];
		if ((data_id !== null) && (data_id !== '')) {
			data_ids.push(data_id);
		} else {
			data_ids = table.attr('data-atable-selected') || null;
			data_ids = JSON.parse(data_ids);
		}

		var link = button.attr('data-modal-link');
		if ((typeof link == 'undefined') || (link == '')) {
			link = 'data';
		}

		var size = button.attr('data-modal-size');
		if ((typeof size == 'undefined') || (size == '')) {
			size = 'md';
		}

		if ((data_ids !== null) && (data_ids.length !== 0)) {
			aTable.loadListingModal(data_ids, link, size);
			$('#aTableModal').fadeIn(200);
		}
	},

	/**
	 * Initieer de columns toggle functie
	 *
	 * @param {object} event
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumn: function(event, table) {

		var minColumns = table.data('min-columns') || 3;

		// Tel aantal zichtbare kolommen
		var visibleColums = 0;
		table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] input[type=checkbox]:checked').each(function() {
			visibleColums++;
		});

		// Als er tenminste 3 kolommen zichtbaar zijn
		if (visibleColums > (parseInt(minColumns) - 1)) {

			// Sla column instellingen op in cookie
			aTable.toggleColumnsSetCookie(table);

			// Toon of verberg de kolom
			var colNumber = $(event.target).attr('data-column');
			var visiblity = $(event.target)[0].checked;
			aTable.toggleColumnsVisibility(table, colNumber, visiblity);

		} else {

			// Zet checkbox weer op true
			event.target.checked = true;
		}

		// Disable minimum aantal columns
		aTable.toggleColumnsMinMax(table);

	},

	/**
	 * Slaat de zichtbare kolommen op in een cookie
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumnsSetCookie: function(table) {
		var obj = {};
		obj['version'] = table.attr('data-version') ?? '';
		obj['columns'] = [];
		table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] input[type=checkbox]').each(function(i, e) {
			var itemColNumber = $(e).attr('data-column');
			obj['columns'][itemColNumber] = false;
			if (this.checked) {
				obj['columns'][itemColNumber] = this.checked;
			}
		});
		let objJSON = JSON.stringify(obj);

		var myDate = new Date();
		myDate.setMonth(myDate.getMonth() + 12);

		document.cookie = aTable.cookieName + '=' + objJSON + ';domain=' + window.app.cookieDomain + ';SameSite=Strict;expires=' + myDate + ';secure;';
	},

	/**
	 * Leest de zichtbare kolommen uit een cookie
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumnsReadCookie: function(table) {

		let cookieBase = document.cookie.split(';');
		let columsSetByCookie = false;

		cookieBase.forEach(function(cookieItem) {

			let cookieSplit = cookieItem.split('=');
			let cookieKey = (cookieSplit[0] || '').trim();

			if (aTable.cookieName === cookieKey) {

				let cookieValue = cookieSplit[1] || '';

				if (aTable.cookieName === cookieKey && 'undefined' !== typeof cookieValue && '' !== cookieValue) {

					let cookieObject = false;

					try {
						let cookieValueDecoded = decodeURIComponent(cookieValue);
						cookieObject = JSON.parse(cookieValueDecoded);
					} catch (error) {
						console.warn('Error parsing cookie JSON:', error);
					}

					if (false !== cookieObject) {
						let tableVersion = table.attr('data-version') ?? '';
						let cookieVersion = cookieObject['version'] ?? '';
						let columns = cookieObject['columns'] ?? [];
						if (cookieVersion === tableVersion) {
							$.each(columns, function(index, value) {
								if (value == false) {
									aTable.toggleColumnsVisibility(table, index, false);
								}
								table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] a input[data-column="' + index + '"]').prop('checked', value);
								columsSetByCookie = true;
							});
						}
					}
				}

			}
		});

		if (!columsSetByCookie) {
			aTable.toggleColumnsDefault(table);
		}

		aTable.toggleColumnsMinMax(table);

	},

	/**
	 * Toont en verbergt kolommen d.m.v. classes
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumnsVisibility: function(table, colNumber, show) {
		var targetClass = 'hide-col-' + (parseInt(colNumber));
		if (show) {
			table.removeClass(targetClass);
		} else {
			table.addClass(targetClass);
		}
	},

	/**
	 * Zet toggle kolom checkboxes op disabled als minimaal aantal geselecteerde kolommen bereikt is
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumnsMinMax: function(table) {

		var maxColumns = table.data('max-columns') || 6;
		var minColumns = table.data('min-columns') || 3;

		var visibleColums = 0;
		var checked = table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] input[type=checkbox]:checked');
		var unChecked = table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] input[type=checkbox]:not(:checked)');

		if ((typeof checked !== 'undefined') && (typeof unChecked !== 'undefined')) {

			checked.each(function() {
				visibleColums++;
			});

			if (visibleColums < (parseInt(minColumns) + 1)) {
				checked.each(function() {
					$(this).attr('disabled', true).closest('a').addClass('disabled');
				});
			} else {
				checked.each(function() {
					$(this).attr('disabled', false).closest('a').removeClass('disabled');
				});
			}

			if (visibleColums > (parseInt(maxColumns) - 1)) {
				unChecked.each(function() {
					$(this).attr('disabled', true).closest('a').addClass('disabled');
				});
			} else {
				unChecked.each(function() {
					$(this).attr('disabled', false).closest('a').removeClass('disabled');

				});
			}

		}

	},

	/**
	 * Zet de default verborgen en getoonde kolommen aan en uit
	 *
	 * @param {object} table jQuery table DOM element
	 * @returns {void}
	 */
	toggleColumnsDefault: function(table) {
		var columnsDump = table.data('columns-data');
		if (columnsDump.length) {
			$.each(columnsDump, function(index, col) {
				table.closest('[data-atable-container]').find('[data-atable-header-toggle-items] a input[data-column="' + (index + 1) + '"]').prop('checked', col.toggleableDefault).trigger('change');
			});
		}
	},

	getRows: function() {
		return aTable.data.data;
	},

	bulkToggleCheckboxColumn: function(table) {
		var target = $('table[data-atable]').find('thead tr th:first-child, tbody tr td:first-child');
		var visible = target.is(':visible');
		if (visible) {
			table.attr('data-atable-bulk-active', false);
			target.addClass('d-none');
		} else {
			table.attr('data-atable-bulk-active', true);
			target.removeClass('d-none');
		}
	},

	bulkCheckboxToggleAll: function(event) {
		var checked = $(event.target).prop('checked');
		var checkboxes = $('table[data-atable] tbody tr td input[type=checkbox]');
		checkboxes.prop('checked', checked).trigger('change');
	},

	bulkCheckboxShiftClickSelect: function(event) {
		var checkboxes = $('table[data-atable] tbody tr td input[type=checkbox]');
		if (typeof aTable.lastChecked === 'undefined') {
			aTable.lastChecked = event.target;
			return;
		}
		if (event.shiftKey) {
			var start = checkboxes.index(event.target);
			var end = checkboxes.index(aTable.lastChecked);
			checkboxes.slice(Math.min(start, end), Math.max(start, end) + 1).prop('checked', aTable.lastChecked.checked);
		}
		aTable.lastChecked = event.target;
	},

	bulkToggleEditButton: function(table) {
		var checkboxes = $('table[data-atable] tbody tr td input[type=checkbox]');
		var bulkbutton = $('[data-atable-header-toolbar-bulkbutton]');
		var bulkEditbutton = $('[data-atable-header-toolbar-bulkEditbutton]');
		var checkedIds = [];
		$.each(checkboxes, function(i, v) {
			var t = $(v);
			if (t.is(':checked')) {
				checkedIds.push(t.data('checkbox-id'));
			}
		});
		var checkedIdsJson = JSON.stringify(checkedIds);
		table.attr('data-atable-selected', checkedIdsJson);
		if (checkboxes.is(':checked')) {
			bulkbutton.addClass('d-none');
			bulkEditbutton.removeClass('d-none');
		} else {
			bulkbutton.removeClass('d-none');
			bulkEditbutton.addClass('d-none');
		}
	}

};

export default aTable;
